import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createUser, fetchUsers, removeUser, updateUser } from "../app/actions";

import { Button, Table } from "react-bootstrap"
import AddEditUserModal from "./AddEditUserModal";
import { withRouter } from "react-router";


const Users = ({history}) => {
    const [showAddEditModal, setShowAddEditModal] = useState(false)
    const [editUser, setEditUser] = useState(null)
    const users = useSelector(store => store.app.users);
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(fetchUsers(1))
    }, [])

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleAddEditSave = (user) => {
        if(user.id) {
            dispatch(updateUser(user.id, user.FirstName, user.LastName, user.Email, user.MobileNumber, user.SystemAdmin))
                .then(() => {
                    dispatch(fetchUsers(1))
                    setShowAddEditModal(false)
                })
        } else {
            dispatch(createUser(user.FirstName, user.LastName, user.Email, user.MobileNumber, user.SystemAdmin))
                .then(() => {
                    dispatch(fetchUsers(1))
                    setShowAddEditModal(false)
                })
        }
    }

    const handleDelete = (user) => {
        if(user.id) {
            dispatch(removeUser(user.id))
                .then(() => {
                    dispatch(fetchUsers(1))
                    setShowAddEditModal(false)
                })
        }
    }

    return <div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h2>Users</h2>
            <Button onClick={()=>{
                setShowAddEditModal(true); 
                setEditUser(null);
            }}>Create user</Button>
        </div>
        <br/>
        <Table striped bordered hover style={{width: "100%"}}>
            <thead>
                <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Mobile Number</th>
                    <th>System Admin</th>
                    <th>Updated</th>
                    <th>Created</th>
                </tr>
            </thead>
            <tbody>
                {users && users.map(user => {
                    const handleUserClick = () => {
                        history.push("/users/" + user.id)
                    }

                    return <tr key={user.id} onClick={handleUserClick}>
                        <td>{user.id}</td>
                        <td>{user.FirstName}</td>
                        <td>{user.LastName}</td>
                        <td>{user.Email}</td>
                        <td>{user.MobileNumber}</td>
                        <td>{user.SystemAdmin}</td>
                        <td>{user.updated_at}</td>
                        <td>{user.created_at}</td>
                    </tr>
                })}
                
            </tbody>
        </Table>
        <AddEditUserModal show={showAddEditModal} editUser={editUser} onHide={hideAddEditModal} onSave={handleAddEditSave} onDelete={handleDelete}/>
    </div>
} 

export default withRouter(Users)